export default "<p>bottom-bar works!</p>\n"